/* eslint-disable max-lines */
export const ERP_LABEL = {
    主营平台: {
        code: '1',
        label: '主营平台',
    },
    主营类目: {
        code: '2',
        label: '主营类目',
    },
}

const PUBLIC_PATH = `https://assets.sursung.com/pkg/static/imgs/202009/28/platform_icons`

/**
 *  产品要求达人用老的
 *  https://devops.aliyun.com/projex/req/JSTGYL-38066# 《店铺：增加抖音、视频号「分销版」店铺订购引导，视频号改名为「微信小店」》
 */
export const darenWXChannel = {
    value: ['微信视频号', 'WXChannel', '微信小店'],
    label: '微信视频号',
    icon: 'https://assets.sursung.com/activity/20241028/77BA1522C58A44248CF528B437DAFEF51730080123168.png',
}

const WXChannelConfigNew = {
    value: ['微信视频号', 'WXChannel', '微信小店'],
    label: '微信小店',
    icon: 'https://assets.sursung.com/activity/20250521/3C25FA13A22F4D4AAFCD8D32F1B237791747796790523.png',
}

export const useWxChannel =
    window.PROJECT_CONFIG.terminalName === window.PROJECT_CONFIG.darenTerminalName ? darenWXChannel : WXChannelConfigNew

const ERP_PLATFORM_ICON = [
    {
        value: ['1688', '阿里巴巴', 'alibaba'],
        label: '1688',
        icon: '1688',
    },
    {
        value: '每日优鲜',
        label: '每日优鲜',
        icon: 'meiriyouxian',
    },
    {
        value: '奥买家',
        label: '奥买家',
        icon: 'aomaijia',
    },
    {
        value: '贝贝',
        label: '贝贝',
        icon: 'beibei',
    },
    {
        value: '哔哩哔哩',
        label: '哔哩哔哩',
        icon: 'bilibili',
    },
    {
        value: ['B站会员购', 'BiliVip'],
        label: 'B站会员购',
        icon: 'https://assets.sursung.com/activity/20250516/66212C6EF5284BAB90070B2EDD736C2A1747365431494.png',
    },
    {
        value: '当当',
        label: '当当',
        icon: 'dangdang',
    },
    {
        value: '点点客',
        label: '点点客',
        icon: 'diandianke',
    },
    {
        value: ['抖仓', 'Doucang'],
        label: '抖仓',
        icon: 'doucang',
    },
    {
        value: ['抖音', '头条放心购', 'douyin', 'TouTiaoFXG'],
        valueLetter: 'douyin',
        label: '抖音',
        icon: 'https://assets.sursung.com/activity/2024_imgs/dis/front/5D87105816E54E029008EFE13D8FB58C1661928392511.png',
    },
    {
        value: '毒',
        label: '毒',
        icon: 'du',
    },
    {
        value: ['ebay', 'eBay'],
        label: 'ebay',
        icon: 'ebay',
    },
    {
        value: '饿了么',
        label: '饿了么',
        icon: 'elme',
    },
    {
        value: 'ezbuy',
        label: 'ezbuy',
        icon: 'ezbuy',
    },
    {
        value: '返利',
        label: '返利',
        icon: 'fanli',
    },
    {
        value: '飞牛',
        label: '飞牛',
        icon: 'feiniu',
    },
    {
        value: '好衣库',
        label: '好衣库',
        icon: 'haoyiku',
    },
    {
        value: ['京东', '京东商城', 'Jos', 'jos'],
        label: '京东',
        icon: 'jingdong',
    },
    {
        value: '卷皮',
        label: '卷皮',
        icon: 'juanpi',
    },
    {
        value: ['聚美', '聚美优品'],
        label: '聚美',
        icon: 'jumei',
    },
    {
        value: ['考拉', '考拉海购', '网易考拉'],
        label: '考拉海购',
        icon: 'kaola',
    },
    {
        value: ['快手', '快手电商', 'KWaiShop', 'kuaishou'],
        valueLetter: 'kuaishou',
        label: '快手',
        icon: 'kuaishou',
    },
    {
        value: ['密选', 'MiXuan'],
        label: '密选',
        icon: 'mixuan',
    },
    {
        value: '蘑菇街',
        label: '蘑菇街',
        icon: 'mogujie',
    },
    {
        value: '魔筷星选',
        label: '魔筷星选',
        icon: 'mokuaixingxuan',
    },
    {
        value: ['拼多多', 'Pinduoduo'],
        label: '拼多多',
        icon: 'pinduoduo',
    },
    {
        value: '社群',
        label: '社群',
        icon: 'shequn',
    },
    {
        value: '苏宁易购',
        label: '苏宁易购',
        icon: 'suning',
    },
    {
        value: ['淘宝', '淘宝天猫', '淘宝/天猫', 'taobao', 'Taobao'],
        label: '淘宝',
        icon: 'tao',
    },
    {
        value: ['天猫', 'Tianmao', 'Tmall'],
        label: '天猫',
        icon: 'tianmao',
    },
    {
        value: '微博',
        label: '微博',
        icon: 'weibo',
    },
    {
        value: ['唯品会', 'vipapis', 'Vipapis'],
        label: '唯品会',
        icon: 'weipinhui2',
    },
    {
        value: '微信',
        label: '微信',
        icon: 'weixin',
    },
    {
        value: ['线下', 'Offline', '线下店铺'],
        label: '线下',
        icon: 'https://assets.sursung.com/activity/20241108/74AAF1076A41481DA6815D0AEFC11B701731033151944.png',
    },
    {
        value: ['小红书', 'Xiaohs'],
        label: '小红书',
        icon: 'xiaohongshu',
    },
    {
        value: '网易严选',
        label: '网易严选',
        icon: 'yanxuan',
    },
    {
        value: '1号店',
        label: '1号店',
        icon: 'yihaodian',
    },
    {
        value: '有品',
        label: '有品',
        icon: 'youpin',
    },
    {
        value: ['WXSupDS', '微信小店供货商'],
        label: '微信小店供货商',
        icon: 'https://assets.sursung.com/activity/20251125/880F89A3FE594A98B8F13CC51BB3DBE31764051570717.png',
    },
    {
        value: ['有赞', 'youzan', '有赞微商城', 'Kdt', 'kdt'],
        label: '有赞',
        icon: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230323/front/8691E1FFDCB0457A9D72613F3C7E76251679544224689.png',
    },
    {
        value: '云集',
        label: '云集',
        icon: 'yunji',
    },
    {
        value: ['自有商场', '自有商城', '商家自有商城', 'Self', 'self'],
        label: '自有商城',
        icon: 'ziyoushangc',
    },

    {
        value: '爱库存',
        label: '爱库存',
        icon: 'aikucun',
    },
    {
        value: '爱奇艺',
        label: '爱奇艺',
        icon: 'aiqiyi',
    },
    {
        value: ['阿里巴巴国际'],
        label: '阿里巴巴国际',
        icon: 'alibabaguoji',
    },
    {
        value: ['Alibaba'],
        label: '阿里巴巴',
        icon: '1688',
    },
    {
        value: '必要',
        label: '必要',
        icon: 'biyao',
    },
    {
        value: '楚楚街',
        label: '楚楚街',
        icon: 'chuchujie',
    },
    {
        value: '达令家',
        label: '达令家',
        icon: 'dalingjia',
    },
    {
        value: ['档口', 'Storefront'],
        label: '档口',
        icon: 'dangkou',
    },
    {
        value: ['大V店', '大v店'],
        label: '大V店',
        icon: 'davdian',
    },
    {
        value: '公主购',
        label: '公主购',
        icon: 'gongzhugou',
    },

    {
        value: ['GOME', '国美在线'],
        label: '国美在线',
        icon: 'guomeizaixian',
    },
    {
        value: '海拍客',
        label: '海拍客',
        icon: 'haipaike',
    },
    {
        value: '孩子王',
        label: '孩子王',
        icon: 'haiziwang',
    },
    {
        value: '好食期',
        label: '好食期',
        icon: 'haoshiqi',
    },
    {
        value: '捷买士',
        label: '捷买士',
        icon: 'jiemaishi',
    },
    {
        value: ['聚货通', 'JHT'],
        label: '聚货通',
        icon: 'juhuotong',
    },
    {
        value: ['微店', '口袋微店'],
        label: '微店',
        icon: 'koudaiweidian',
    },
    {
        value: ['Lazada', 'lazada'],
        label: 'Lazada',
        icon: 'Lazada',
    },
    {
        value: '每日一淘',
        label: '每日一淘',
        icon: 'meiriyitao',
    },
    {
        value: '美柚',
        label: '美柚',
        icon: 'meiyou',
    },
    {
        value: ['门店自营', 'POS'],
        label: '门店自营',
        icon: 'mendianziying',
    },
    {
        value: '萌推',
        label: '萌推',
        icon: 'mengtui',
    },
    {
        value: '蜜芽',
        label: '蜜芽',
        icon: 'miya',
    },
    {
        value: '启博微分销',
        label: '启博微分销',
        icon: 'qiboweifenxiao',
    },
    {
        value: '融e购',
        label: '融e购',
        icon: 'rongegou',
    },
    {
        value: ['shopee', 'Shopee', '虾皮'],
        label: 'Shopee',
        icon: 'shopee',
    },
    {
        value: '顺联动力',
        label: '顺联动力',
        icon: 'shunliandongli',
    },
    {
        value: '寺库',
        label: '寺库',
        icon: 'siku',
    },
    {
        value: '速卖通',
        label: '速卖通',
        icon: 'sumaitong',
    },
    {
        value: ['淘工厂', 'C2M'],
        label: '淘工厂',
        icon: 'https://assets.sursung.com/activity/20251208/600024D235C0460984AFE4EB5392A6941765162910599.png',
    },
    {
        value: '万物心选',
        label: '万物心选',
        icon: 'wanwuxinxuan',
    },
    {
        value: '未来集市',
        label: '未来集市',
        icon: 'weilaijishi',
    },
    {
        value: '微盟',
        label: '微盟',
        icon: 'weimeng',
    },
    {
        value: ['Wish', 'wish'],
        label: 'Wish',
        icon: 'wish',
    },
    {
        value: '下厨房',
        label: '下厨房',
        icon: 'xiachufang',
    },
    {
        value: ['亚马逊', 'amazon'],
        label: '亚马逊',
        icon: 'yamaxun',
    },
    {
        value: ['洋葱omall', '洋葱'],
        label: '洋葱',
        icon: 'yangcong',
    },
    {
        value: '壹钱包',
        label: '壹钱包',
        icon: 'yiqianbao',
    },
    {
        value: '邮乐',
        label: '邮乐',
        icon: 'youle',
    },
    {
        value: '折800',
        label: '折800',
        icon: 'zhe800',
    },
    {
        value: '天猫超市',
        label: '天猫超市',
        icon: 'tianmaochaoshi',
    },
    {
        value: '团好货',
        label: '团好货',
        icon: 'https://assets.sursung.com/activity/2024_imgs/dis/front/0F2C50E999204489836B2EC789557ADA1654739337947.png',
    },
    {
        value: ['微信小商店', 'WXStore'],
        label: '微信小商店',
        icon: 'https://assets.sursung.com/activity/2024_imgs/dis/front/8F61D3A6B5134805A57170391C6431791661928372613.png',
    },
    useWxChannel,
    {
        value: ['微盟零售', 'WeimobLS'],
        label: '微盟零售',
        icon: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/44991AE23E00486F88B720EED21B13B51681703066549.png',
    },
    {
        value: ['美团闪购', 'MTShanGou'],
        label: '美团闪购',
        icon: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/A904CFE21A8349CDACCAD8BB3AB21CD61681703091483.png',
    },
    {
        value: ['京东到家', 'JDDaoJia'],
        label: '京东到家',
        icon: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/9F82F70BF4FB4C1D9812FC0AC3AE2C711681703112826.png',
    },
    {
        value: ['快团团', 'KuaiTT'],
        label: '快团团',
        icon: 'https://assets.sursung.com/activity/20230511/20D001B1195545DEAC01FA31644032031683790914352.png',
    },
    {
        value: ['得物', 'DeWu'],
        label: '得物',
        icon: 'https://assets.sursung.com/activity/20230726/CBFD32CAA30A48E7A12A831520D3E48B1690338627830.png',
    },
    {
        value: ['微盟微商城', 'WeimobEC'],
        label: '微盟微商城',
        icon: 'https://assets.sursung.com/activity/20230511/FE7398ED43AA4917B697381934C15BB81683791616756.png',
    },
    {
        value: ['饿百零售', 'ElementLS', '淘宝闪购'],
        label: '淘宝闪购',
        icon: 'https://assets.sursung.com/activity/20251126/A36695914B404BD3B6ACC000B9D3A5741764145762634.png',
    },
    {
        value: ['微商相册', 'WSPhoto'],
        label: '微商相册',
        icon: 'https://assets.sursung.com/activity/20251014/2BA875F8D60E4D0CA854FA026FF32BC01760426840671.png',
    },
].map(v => {
    return {
        ...v,
        icon: /^http:\/\/|^https:\/\/|^\/\//.test(v.icon) ? v.icon : `${PUBLIC_PATH}/${v.icon}.png`,
    }
})

export const getPropByName = name => {
    const target = ERP_PLATFORM_ICON.find(v => {
        if (Array.isArray(v.value)) {
            return v.value.some(c => c === name)
        }

        return v.value === name
    })

    return {
        ...(target || {}),
        label: name,
        icon:
            target?.icon ||
            'https://assets.sursung.com/activity/2024_imgs/dis/front/246E33BCD4E94E82A34D4AB465AE35641631792847042.jpg',
    }
}

// 此方法弃用
export const getPropByLetterName = name => {
    const target = ERP_PLATFORM_ICON.find(v => {
        return v.valueLetter === name
    })
    return {
        ...(target || {}),
        label: name,
    }
}

// 根据平台类型获取图标及平台名称
export const getPropByPlatType = type => {
    const target = ERP_PLATFORM_ICON.find(v => {
        if (Array.isArray(v.value)) {
            return v.value.some(c => c?.toLowerCase?.() === type?.toLowerCase?.())
        }

        return v.value?.toLowerCase?.() === type?.toLowerCase?.()
    })

    return {
        ...(target || {}),
        name: (target && target.label) || '',
        type,
        icon:
            target?.icon ||
            'https://assets.sursung.com/activity/2024_imgs/dis/front/246E33BCD4E94E82A34D4AB465AE35641631792847042.jpg',
    }
}
